<div class="year-multi-picker-wrapper">
  <label *ngIf="label" class="year-multi-picker-label">{{ label | translate }}</label>

  <div class="year-multi-picker-container">
    <!-- Selected years chips -->
    <div class="selected-years" *ngIf="selectedYears.length > 0">
      <span
        *ngFor="let year of selectedYears; let i = index"
        class="year-chip year-chip-selected"
        [style.border-color]="'#9ca3af'"
        [style.color]="'#4b5563'">
        {{ year }}
        <i class="pi pi-times remove-icon" (click)="removeYear(year)" *ngIf="!disabled"></i>
      </span>
    </div>

    <!-- Year picker for adding new years -->
    <div class="picker-container" *ngIf="selectedYears.length < maxYears && !disabled">
      <p-datepicker
        [(ngModel)]="pickerValue"
        (ngModelChange)="onYearSelect($event)"
        (onBlur)="onBlur()"
        [placeholder]="placeholder | translate"
        [disabled]="disabled"
        [showIcon]="showIcon"
        [iconDisplay]="'input'"
        [dateFormat]="'yy'"
        [view]="'year'"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [autofocus]="false"
        styleClass="year-picker-input w-full"
        appendTo="body"
        panelStyleClass="year-picker-panel"
      >
      </p-datepicker>
    </div>
  </div>
</div>
